import dayjs from "dayjs";
export default function HomeCarousel({ events }) {
  const start_date = dayjs(events.start_date).format("DD-MMMM-YYYY");
  const end_date = dayjs(events.end_date).format("DD-MMMM-YYYY");
  return (
    <div className="relative w-full h-[80vh] overflow-hidden">
      <div className="flex transition-transform duration-700 ease-out">
        <div
          key={events.id}
          className="w-full h-[80vh] flex-shrink-0 relative transition-transform duration-700 ease-out"
        >
          <img
            src={events.banner_image}
            className="w-full h-full object-cover"
            alt={events.theme}
          />

          <div className="absolute inset-0 bg-black/40 flex flex-col justify-center px-8 md:px-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white drop-shadow-lg mb-4 md:w-3/4">
              {events.name}
            </h2>
            <p className="text-white mt-2 text-sm md:text-2xl italic mb-4 font-bold">
              {events.theme}
            </p>
            <p className="text-white mt-2 md:text-2xl">
              <strong>
                📅 Date: <span>{start_date}</span> - <span>{end_date}</span>
              </strong>
            </p>
            <p className="text-white mt-2 md:text-2xl">
              <strong>📍 Venue: {events.venue}</strong>
            </p>
            <p className="text-white text-lg md:text-xl max-w-2xl drop-shadow-lg mt-4">
              {events.slide_description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
